<template>
  <v-dialog
    v-model="isOpenModal"
    :scrim="false"
    scrollable
    :fullscreen="!$vuetify.breakpoint.mobile"
    :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : 'slide-x-transition'"
    @click:outside="close"
  >
    <v-card
      class="border-radius-0"
      :class="$vuetify.breakpoint.mobile ? 'help-card-mobile' : ''"
    >
      <div>
        <div class="d-flex bg-titre">
          <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
            {{ titreFormatted }}
          </div>
          <v-btn
            text
            class="align-self-center"
            @click="close"
          >
            <v-icon color="secondary">
              mdi-close
            </v-icon>
          </v-btn>
        </div>
        <div :class="$vuetify.breakpoint.mobile ? 'over' : ''">
          <slot
            name="baseCardHelpContent"
          />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import capitalize from '@/filters/string.filter'

export default {
  name: 'HelpModal',
  props: {
    titre: {
      type: String,
      default: 'Information'
    },
    isOpenModalHelp: {
      type: Boolean,
      default:false
    }
  },
  data () {
    return {
      isOpenModal: false
    }
  },
  computed: {
    titreFormatted (){
      return capitalize.capitalize(this.titre)
    }
  },
  created () {
    this.isOpenModal = this.isOpenModalHelp
  },

  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.help-card-mobile {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  max-height: calc(100% - 70px);
}
.over {
  max-height: 600px;
  overflow: auto;
}
.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
.border-radius-0 {
  border-radius: 0px !important;
}
</style>